import { ReactNode, useEffect, useState } from 'react';
interface SecureLayoutProps {
  children: ReactNode;
  maxWidth?: number;
  className?: string;
}
const THEME = {
  foreground: '#ffffff',
};
export default function AnimationLayout({
  children,
  maxWidth = 400,
  className = '',
}: SecureLayoutProps) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setMounted(true), 50);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className={className}
      style={{
        minHeight: '90vh',
        width: '100%',
        background: 'transparent',
        color: THEME.foreground,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden',
        padding: 20,
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      }}
    >
      <style>{`
        @keyframes scanDrift {
          0% {
            background-position: 0 0;
          }
          100% {
            background-position: 0 -120px;
          }
        }

        @keyframes floatUp {
          from {
            opacity:0;
            transform:translateY(18px);
          }

          to {
            opacity:1;
            transform:translateY(0);
          }
        }
      `}</style>

      {/* Scan Background */}
      <div
        aria-hidden
        style={{
          position: 'absolute',
          inset: 0,
          backgroundImage:
            'repeating-linear-gradient(to bottom, rgba(255,255,255,0.04) 0px, rgba(255,255,255,0.04) 1px, transparent 1px, transparent 60px)',
          backgroundSize: '100% 120px',
          animation: 'scanDrift 9s linear infinite',
        }}
      />

      {/* Gradient Glow */}
      <div
        aria-hidden
        style={{
          position: 'absolute',
          inset: 0,
          background: `
          radial-gradient(
            ellipse 700px 500px at 50% 38%,
            rgba(255,255,255,0.10),
            transparent 65%
          ),

          radial-gradient(
            ellipse 600px 420px at 50% 90%,
            rgba(4,38,102,0.35),
            transparent 70%
          )
          `,
        }}
      />

      {/* Page Content */}
      <div
        style={{
          position: 'relative',
          zIndex: 2,
          width: '100%',
          maxWidth,
          opacity: mounted ? 1 : 0,
          transform: mounted ? 'translateY(0)' : 'translateY(18px)',
          transition: 'all .6s ease',
        }}
      >
        {children}
      </div>
    </div>
  );
}
